import type { ReactNode } from 'react'
import { Label } from './Label'

type FormFieldProps = {
  id: string
  label: ReactNode
  required?: boolean
  error?: string
  hint?: ReactNode
  children: ReactNode
}

export function FormField({ id, label, required, error, hint, children }: FormFieldProps) {
  return (
    <div>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      {children}
      {hint && !error && <p className="mt-1 text-[11px] text-gray-500">{hint}</p>}
      {error && (
        <p className="mt-1 text-[11px] text-red-700" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
